module.exports = "pegasus_template/assets/twitter-bird-tiny.png";